import { Logo } from "@/components/Logo";
import { CONTACT, waLink, WA_DEFAULT_MSG, scrollToSection } from "@/lib/site";

const NAV = [
  { label: "Services", action: () => scrollToSection("services") },
  { label: "Coverage", action: () => scrollToSection("coverage") },
  { label: "Why NGCONDE", action: () => scrollToSection("why") },
  { label: "FAQ", action: () => scrollToSection("faq") },
];

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-[#060A11]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <a href="/" data-testid="footer-logo-link" className="group inline-block">
              <Logo />
            </a>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              Nationwide South African courier and logistics contractor — parcel
              delivery and bakkie transport capacity for businesses that move.
            </p>
            <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
              Serving all 9 provinces
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-500">
              Navigate
            </p>
            <ul className="mt-4 space-y-2.5">
              {NAV.map((n) => (
                <li key={n.label}>
                  <a
                    href={`/#${n.label.toLowerCase().replace(/\s+/g, "")}`}
                    onClick={(e) => {
                      e.preventDefault();
                      n.action();
                    }}
                    className="text-sm text-slate-300 transition-colors hover:text-[#FF6B00]"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="/contact" className="text-sm text-slate-300 transition-colors hover:text-[#FF6B00]">
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="/privacy"
                  data-testid="nav-link-privacy"
                  className="text-sm text-slate-300 transition-colors hover:text-[#FF6B00]"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-500">
              Contract Services
            </p>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-300">
              <li>Parcel Delivery Operations</li>
              <li>Dedicated Bakkie Transport</li>
              <li>Last-Mile Subcontracting</li>
              <li>Scheduled Distribution Runs</li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-500">
              Contact
            </p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <a
                  href={waLink(WA_DEFAULT_MSG)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="text-[#25D366] transition-colors hover:text-white"
                >
                  WhatsApp {CONTACT.whatsappDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${CONTACT.callNumber}`}
                  data-testid="footer-call"
                  className="text-slate-300 transition-colors hover:text-[#FF6B00]"
                >
                  {CONTACT.callDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email"
                  className="break-all text-slate-300 transition-colors hover:text-[#FF6B00]"
                >
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
            © {year} NGCONDE Courier Service — South Africa
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
            Partner enquiries handled POPIA-aligned
          </p>
        </div>
      </div>
    </footer>
  );
};
